import { IAggFunc, IAggFuncParams } from 'ag-grid-community';
import { FDIterator } from '../../../PortfolioOverview/components/OverviewTable/StandardIterators';
import { runAggregationIterator } from '../../../PortfolioOverview/components/OverviewTable/columns/AggregationConfigs';
import { ICaptableSummaryRowData2 } from './CaptableSummaryRowData2';

export interface IOwnershipAggResult {
  value: number | null;
  sharesHeld: number;
}

export interface IOutstandingOwnershipAggResult {
  value: number | null;
  outstandingShares: number;
}

export interface ICaptableSummaryGridContext {
  totalSharesHeld: number;
  totalOutstandingShares: number;
}

export function captableOwnershipIterator(
  totalSharesHeld: number
): FDIterator<IOwnershipAggResult, { sharesHeld?: number | null }> {
  let sumSharesHeld = 0;

  return {
    get value(): IOwnershipAggResult {
      const calculated = totalSharesHeld ? (sumSharesHeld / totalSharesHeld) * 100 : null;
      return { value: calculated, sharesHeld: sumSharesHeld };
    },
    next(data: { sharesHeld?: number | null }) {
      sumSharesHeld += data.sharesHeld ?? 0;
    },
  };
}

export const captableOwnershipAggFunc: IAggFunc<ICaptableSummaryRowData2> = (
  params: IAggFuncParams<ICaptableSummaryRowData2>
) => {
  const context = params.context as ICaptableSummaryGridContext | undefined;
  const totalSharesHeld = context?.totalSharesHeld ?? 0;
  return runAggregationIterator(params, captableOwnershipIterator(totalSharesHeld));
};

export function captableOutstandingOwnershipIterator(
  totalOutstandingShares: number
): FDIterator<IOutstandingOwnershipAggResult, { outstandingShares?: number | null }> {
  let sumOutstandingShares = 0;

  return {
    get value(): IOutstandingOwnershipAggResult {
      const calculated = totalOutstandingShares
        ? (sumOutstandingShares / totalOutstandingShares) * 100
        : null;
      return { value: calculated, outstandingShares: sumOutstandingShares };
    },
    next(data: { outstandingShares?: number | null }) {
      sumOutstandingShares += data.outstandingShares ?? 0;
    },
  };
}

export const captableOutstandingOwnershipAggFunc: IAggFunc<ICaptableSummaryRowData2> = (
  params: IAggFuncParams<ICaptableSummaryRowData2>
) => {
  const context = params.context as ICaptableSummaryGridContext | undefined;
  const totalOutstandingShares = context?.totalOutstandingShares ?? 0;
  return runAggregationIterator(params, captableOutstandingOwnershipIterator(totalOutstandingShares));
};

export const captableSummaryAggFuncs: Record<string, IAggFunc<ICaptableSummaryRowData2>> = {
  captableOwnershipAggFunc,
  captableOutstandingOwnershipAggFunc,
};
